/* NBMobile iPhone category model chips. Filters only visible catalogue cards.
   Shopify native sort, pagination, products and cart functionality remain intact. */
(function(){
  'use strict';
  const containers = new WeakMap();
  function setup(root){
    if(!root || containers.has(root))return;
    const chips = Array.from(root.querySelectorAll('[data-nb28-filter]'));
    const count = root.querySelector('[data-nb28-count]');
    const empty = root.querySelector('[data-nb28-empty]');
    if(!chips.length) return;
    const modelValue = new URLSearchParams(window.location.search).get('nb_model');
    const modelMap = {'18-pro-max':'iphone 18 pro max','18-pro':'iphone 18 pro','17-pro-max':'iphone 17 pro max','17-pro':'iphone 17 pro','17':'iphone 17'};
    const initialModel = modelMap[modelValue];
    let selected = initialModel && chips.some(c=>c.getAttribute('data-nb28-filter')===initialModel) ? initialModel : 'all';
    let guard=false;
    function update(){
      const cards=Array.from(root.querySelectorAll('#product-grid > li.grid__item[data-nb28-title]'));
      let displayed=0;
      cards.forEach(function(card){
        const title=(card.getAttribute('data-nb28-title')||'').toLowerCase();
        const available=card.getAttribute('data-nb28-available')==='true';
        let matches=true;
        if(selected==='in-stock') matches=available;
        else if(selected==='iphone 18 pro') matches=title.includes('iphone 18 pro')&&!title.includes('iphone 18 pro max');
        else if(selected==='iphone 17') matches=title.includes('iphone 17')&&!title.includes('iphone 17 pro');
        else if(selected==='iphone 17 pro') matches=title.includes('iphone 17 pro')&&!title.includes('iphone 17 pro max');
        else if(selected!=='all') matches=title.indexOf(selected.toLowerCase())>=0;
        card.hidden=!matches;
        if(matches) displayed++;
      });
      if(count) count.textContent=selected==='all'?String(root.getAttribute('data-nb28-total')||cards.length):String(displayed);
      const visibleTotal=selected==='all'?String(root.getAttribute('data-nb28-total')||cards.length):String(displayed);
      root.querySelectorAll('#ProductCountDesktop, #ProductCount').forEach(function(counter){
        const current=counter.textContent;
        const next=current.replace(/\d[\d.,\s\u00a0\u202f]*?(?=\s+[^\d.,\s]|$)/,visibleTotal);
        if(next!==current) counter.textContent=next;
      });
      if(empty) empty.classList.toggle('is-visible',displayed===0);
      chips.forEach(function(chip){
        const on=chip.getAttribute('data-nb28-filter')===selected;
        chip.classList.toggle('is-active',on);
        chip.setAttribute('aria-pressed',on?'true':'false');
      });
    }
    chips.forEach(function(chip){
      chip.addEventListener('click',function(){
        selected=chip.getAttribute('data-nb28-filter')||'all';
        update();
      });
    });
    const grid=root.querySelector('#ProductGridContainer');
    if(grid && typeof MutationObserver!=='undefined'){
      new MutationObserver(function(){
        if(guard)return;
        guard=true;
        window.requestAnimationFrame(function(){guard=false;update()});
      }).observe(grid,{childList:true,subtree:true});
    }
    containers.set(root,true);
    update();
  }
  function init(){document.querySelectorAll('.nb28-collection-mode').forEach(setup)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();